import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateComponent } from './components/translate.component';
import { TranslateDirective } from './directives/translate.directive';
import { TranslateService } from './services/translate.service';

@NgModule({
	imports: [
		CommonModule,
	],
	declarations: [
		TranslateDirective,
		TranslateComponent,
	],
	exports: [
		TranslateDirective,
		TranslateComponent,
	],
})
export class TranslateModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: TranslateModule,
			providers: [TranslateService],
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/i18n/translate.module.ts